const back_url = process.env.back_url

// 不需要登录的路由组件名称
const not_need_login_name = ['login']


// WEBPACK FOOTER //
// ./src/utils/commonValue.js